import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=45934b1a&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=ts"
export * from "./appointment.vue?vue&type=script&lang=ts"
import style0 from "./appointment.vue?vue&type=style&index=0&id=45934b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45934b1a",
  null
  
)

export default component.exports